import { createSelector } from '@reduxjs/toolkit';

const getGiftVouchers = (state) => state?.sealink?.giftVouchers || [];

const getGiftVoucherTitle = createSelector(
  [getGiftVouchers, (state, resource_id) => resource_id],
  (vouchers, resource_id) =>
    vouchers.find((voucher) => voucher.qtResourceId === resource_id)
      ?.giftVoucherTitle || ''
);

export { getGiftVoucherTitle };
